import { fetcher } from '@commenda/utils';

export async function deleteBankAccount(
  bankAccountId: string,
  token?: string | undefined
): Promise<{
  success: boolean;
  error: string | null;
}> {
  try {
    const res = await fetcher(
      `bankAccount/${bankAccountId}`,
      {
        method: 'DELETE',
      },
      token
    );

    if (!res.ok) {
      const body = (await res.json().catch(() => null)) as {
        message?: string;
      } | null;
      return {
        success: false,
        error: body?.message ?? null,
      };
    }

    return {
      success: true,
      error: null,
    };
  } catch {
    return {
      success: false,
      error: null,
    };
  }
}
